import React, { useState } from 'react';
import ImageIcon from '@material-ui/icons/Image';
// https://github.com/vutoan266/react-images-uploading
import ImageUploading, { ImageListType } from 'react-images-uploading';
import ActionButton from '../ActionButton';
import { Tooltip, ClickAwayListener } from '@material-ui/core';

interface IProps {
    images: ImageListType;
    setImages: (imageList: never[]) => void;
}

export default function AddImageAction({ images, setImages }: IProps) {
    const maxNumber = 1;
    const disabled = images.length >= maxNumber;
    const [openToolTip, setOpenToolTip] = useState(false);

    function onChange(imageList: ImageListType) {
        setImages(imageList as never[]);
    }

    function handleTooltipClose() {
        setOpenToolTip(false);
    }

    function handleTooltipOpen() {
        setOpenToolTip(true);
    }

    return (
        <div className="App">
            <ImageUploading multiple value={images} onChange={onChange} maxNumber={maxNumber}>
                {({ onImageUpload }) => (
                    <ClickAwayListener onClickAway={handleTooltipClose}>
                        <div>
                            <Tooltip
                                PopperProps={{
                                    disablePortal: true,
                                }}
                                onClose={handleTooltipClose}
                                open={openToolTip}
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                                title="Max images reached"
                            >
                                <div>
                                    <ActionButton
                                        icon={ImageIcon}
                                        first
                                        onClick={disabled ? handleTooltipOpen : onImageUpload}
                                    />
                                </div>
                            </Tooltip>
                        </div>
                    </ClickAwayListener>
                )}
            </ImageUploading>
        </div>
    );
}
